import React, { useEffect, useMemo, useRef, useState } from 'react';
import Views from '@components/OrderStatusManager/views';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getObjectValue } from '@utility/utills';
import { parseCheck, getChecksList, getDueTime } from '../Fireboard/common';
import {
  getDeliverTo,
  getOrderNameFromOrderId,
  getTimeInHrsMins,
  getCheckSourceIcon,
  getCheckInTime,
  getModeIconBgColor,
  getFormattedOpenOrCloseDate,
  getElapsedTimeInMs,
  getOrderNameFromId,
  getChecksBasedOnFilters,
  getChecksBasedOnPaidStatus,
  getChecksBasedOnEmployee,
  getChecksBasedOnLocation,
} from '@utility/fireboardUtil';
import {
  newUpdateOrderStatus,
  newOrderPickedUp,
} from '../../reducers/fireboard';
import { setNotification, setErrorPopUp } from '@reducers/notification';
import { LABEL } from '../../veriables';
import { useOutletContext } from 'react-router-dom';
import { getFormatedPhoneNumber } from '@utility/helperFunction';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';
import { getPopupConfig } from '@components/common/Popup/index';

const OrderStatusManager = props => {
  const { tableData, currentMode, venueStores } = props;
  const {
    selectedCheck,
    setSelectedCheck,
    setIsFlip,
    setPopup,
    popup,
    setIsExpanded,
    isExpanded,
    currentView,
    handleExpandedRightSection,
    filtersState,
    searchFieldValue,
    orderType,
  } = useOutletContext();

  const storeInfo = getObjectValue(() =>
    JSON.parse(window.sessionStorage.getItem('auth'), false)
  );
  const deviceInfo = getObjectValue(() =>
    JSON.parse(window.sessionStorage.getItem('deviceInfo'), false)
  );
  const [pendingCheckList, setPendingCheckList] = useState([]);
  const [inProgressCheckList, setInProgressCheckList] = useState([]);
  const [completeCheckList, setCompleteCheckList] = useState([]);
  const [pickedUpCheckList, setPickedUpCheckList] = useState([]);
  const [isPickedUpCol, setIsPickedUpCol] = useState(false);
  const [filteredCheckListItem, setFilteredCheckListItem] = useState([]);
  let checks = new Map();
  const orderStatusType = filtersState['Status'] || [];
  const employeeType = filtersState['Employee'] || [];
  const locationType = filtersState['Location'] || [];
  const [activeCheckFilter, setActiveCheckFilter] = useState('sourceType');
  const filteredChecksRef = useRef([]);
  const currency = LABEL().CURRENCY_SYMBOL;
  const { supportsTipsOnTotalAmount = false, suppressTipsOnFireBoard = false } =
    storeInfo?.serverAppFeatures || {};
  useEffect(() => {
    setChecks(tableData);
  }, [tableData, filtersState, searchFieldValue]);

const firstSelectedId = useMemo(() => {
  const lists = [
    pendingCheckList,
    inProgressCheckList,
    completeCheckList,
    pickedUpCheckList,
  ];
  return lists.find(list => list?.length > 0)?.[0]?.id ?? null;
}, [
  pendingCheckList,
  inProgressCheckList,
  completeCheckList,
  pickedUpCheckList
]);

useEffect(() => {
  setSelectedCheck(firstSelectedId);
}, [firstSelectedId, currentView, currentMode, filtersState]);

  useEffect(() => {
    const CheckFilterType = deviceInfo?.deviceGroup?.fireBoardCheckFilterType;
    if (CheckFilterType === 0 || deviceInfo?.deviceGroup === null) {
      setActiveCheckFilter('sourceType');
    } else if (CheckFilterType === 1) {
      setActiveCheckFilter('orderType');
    } else if (CheckFilterType === 2) {
      setActiveCheckFilter('revenueCenter');
    }
  }, [filtersState]);

  const getPopup = (type, heading, message) => {
    const popup = type === 'spinner' ? getPopupConfig('spinner') : null;
    if (heading) {
      popup.heading = heading;
    }
    if (message) {
      popup.message = message;
    }
    setPopup(popup);
  };

  const setChecks = check => {
    const allChecks = Object.values(check);
    let checksMap = new Map();

    allChecks &&
      allChecks?.forEach(chk => {
        const existingCheck = checks[chk.id];
        let updatedCheck = chk;
        if (existingCheck) {
          updatedCheck = {
            ...chk,
            selectedForBatchPreauth:
              existingCheck?.selectedForBatchPreauth || false,
          };
        }
        checksMap.set(chk.id, parseCheck(updatedCheck));
      });
    checks = checksMap;
    toggleSelection();
  };

  const filterByOrderTypes = () => {
    let allCheckList = [];
    if (
      orderType === null ||
      (Array.isArray(orderType) && orderType.length === 0) ||
      (Array.isArray(orderType) &&
        orderType.length === 1 &&
        orderType[0].value === 'All')
    ) {
      allCheckList = getChecksList(checks, 'All', storeInfo, activeCheckFilter);
    } else {
      orderType?.forEach(eachType => {
        const checkArr = getChecksList(
          checks,
          eachType,
          storeInfo,
          activeCheckFilter
        );
        if (Array.isArray(checkArr)) {
          allCheckList = [...allCheckList, ...checkArr];
        }
      });
    }
    const uniqueChecks = Array.from(
      new Map(allCheckList.map(item => [item.id, item])).values()
    );
    return uniqueChecks;
  };

  const filterByOrderStatus = checkList => {
    let filteredChecksList = [];
    //no status filter is selected
    if (
      orderStatusType === null ||
      (Array.isArray(orderStatusType) && orderStatusType.length === 0)
    ) {
      filteredChecksList = checkList;
    } else {
      const isWalkUpIncluded = orderType.some(op => op.value === 'Walk up');
      const isCurbsideIncluded = orderType.some(op => op.value === 'Curbside');
      let checksArray = [];
      orderStatusType &&
        orderStatusType?.length > 0 &&
        orderStatusType.forEach(eachStatus => {
          const checks = getChecksBasedOnFilters(
            checkList,
            eachStatus.value,
            isWalkUpIncluded,
            isCurbsideIncluded
          );

          if (Array.isArray(checks)) {
            checksArray = [...checksArray, ...checks];
          }
        });
      // remove duplicate checks
      filteredChecksList = Array.from(
        new Map(checksArray.map(item => [item.id, item])).values()
      );
    }
    return filteredChecksList;
  };

  const toggleSelection = () => {
    const checkList = filterByOrderTypes();
    let filteredChecksList = filterByOrderStatus(checkList);
    setFilteredCheckListItem(filteredChecksList);
    sessionStorage.setItem('chequeCount', checkList?.length);
    const showPaid = filtersState?.paidAndUnpaid ?? true;
    filteredChecksList = getChecksBasedOnPaidStatus(
      filteredChecksList,
      showPaid
    );
    if (employeeType?.length > 0) {
      filteredChecksList = getChecksBasedOnEmployee(
        filteredChecksList,
        employeeType
      );
    }
    if (locationType?.length > 0) {
      filteredChecksList = getChecksBasedOnLocation(
        filteredChecksList,
        locationType
      );
    }

    // serach action on fiterlist
    if (searchFieldValue.trim() !== '') {
      const lowerSearch = searchFieldValue.toLowerCase().trim();
      filteredChecksList = filteredChecksList.filter(
        check =>
          (check.phoneNumber &&
            check.phoneNumber.toLowerCase().includes(lowerSearch)) ||
          (check.checkNumber &&
            check.checkNumber.toLowerCase().includes(lowerSearch)) ||
          (check.checkInNote &&
            check.checkInNote.toLowerCase().includes(lowerSearch)) ||
          (check.stationName &&
            check.stationName.toLowerCase().includes(lowerSearch))
      );
    }
    filteredChecksRef.current = filteredChecksList;
    setFilteredCheckListItem(filteredChecksList);
  };

  const updateOrderStatus = (item, type) => {
    const { id: storeId } = storeInfo || {};
    const payload = {
      checkHeaderId: item.id,
      deviceId: deviceInfo.deviceId,
      storeId,
    };
    getPopup('spinner');
    props
      .newUpdateOrderStatus(payload, type)
      .then(response => {
        setPopup(null);
        props.setNotification({
          type: 'success',
          message: FLABEL().TOAST_ORDER_STATUS,
        });
      })
      .catch(error => {
        setPopup(null);
        props.setErrorPopUp({
          res: error.message,
        });
      });
  };

  const pickedUp = item => {
    const { id: storeId } = storeInfo || {};
    const payload = {
      checkHeaderId: item.id,
      storeId,
      deviceId: deviceInfo.deviceId,
    };
    getPopup('spinner');
    props
      .newOrderPickedUp(payload, 'pickedUp')
      .then(() => {
        setPopup(null);
        props.setNotification({
          type: 'success',
          message: FLABEL().TOAST_ORDER_STATUS,
        });
      })
      .catch(error => {
        setPopup(null);
        props.setErrorPopUp({
          res: error.message,
        });
      });
  };

  const onFooterButtonPress = (actionTypes, check) => {
    switch (actionTypes) {
      case 'notify':
        handleExpandedRightSection('notifyGuest');
        break;
      case 'inProgress':
        updateOrderStatus(check, 'inProgress');
        break;
      case 'complete':
        updateOrderStatus(check, 'complete');
        break;
      case 'pickedUp':
        pickedUp(check, false);
        break;
      case 'print':
        handleExpandedRightSection('print');
        break;
      case 'receipt':
        handleExpandedRightSection('receipt');
        break;
      default:
        console.warn(`footer action - ${actionTypes} is not handled!!!`);
    }
  };

  const getTimeInMilliSeconds = date => {
    if (!date) return 0;
    const convertedDate = date?.includes('Z')
      ? new Date(date)
      : new Date(date + 'Z');
    return convertedDate.getTime();
  };

  const getComingUpTime = (dueDate, prepWindow) => {
    const dueTime = getTimeInMilliSeconds(dueDate);
    const comingUpTime = dueTime - 2 * prepWindow * 60 * 1000;
    return comingUpTime;
  };

  const getPrepTime = (dueDate, prepWindow) => {
    const dueTime = getTimeInMilliSeconds(dueDate);
    const prepTime = dueTime - prepWindow * 60 * 1000;
    return prepTime;
  };

  const cutoffTimeCalculation = (check, storeInfo, deviceGroup) => {
    if (!check || !storeInfo) return {};

    const { prepWindow } = storeInfo || {}; // prepWindow is in minutes
    const { orders } = check || {};
    const { pickupDate, orderDate } = orders?.[0] || {}; // Extract first order
    const dueDate = pickupDate || orderDate;

    if (!dueDate) return {}; // Ensure dueDate exists

    const comingUpTime = getComingUpTime(dueDate, prepWindow);
    const prepTime = getPrepTime(dueDate, prepWindow);

    let warningTime = null,
      errorTime = null,
      clearTime = null;

    if (!FireboardUtils?.isObjectBlank(deviceGroup)) {
      const {
        orderUpWarningTime,
        orderUpErrorTime,
        orderUpClearTime,
      } = deviceGroup;

      warningTime = orderUpWarningTime
        ? getWarningOrErrorOrClearTime(dueDate, orderUpWarningTime)
        : null;
      errorTime = orderUpErrorTime
        ? getWarningOrErrorOrClearTime(dueDate, orderUpErrorTime)
        : null;
      clearTime = orderUpClearTime
        ? getWarningOrErrorOrClearTime(dueDate, orderUpClearTime)
        : null;
    }

    return { comingUpTime, prepTime, warningTime, errorTime, clearTime };
  };

  const refreshSectionChecks = checks => {
    const pendingChecks = [];
    const inProgressChecks = [];
    const completeChecks = [];
    const pickedUpChecks = [];

    const currentTime = new Date().getTime();

    const getOrderFlags = (check, currentTime) => {
      const { orders, sourceType, unpaidAmount, tickets, totalAmount } = check;
      const [order0] = orders || [];
      const { pickUpStatus, orderStatusId } = order0 || {};
      const currentOrderStatusType = getOrderNameFromId(orderStatusId);

      const flags = {
        isPending: false,
        isInProgress: false,
        isComplete: false,
        isPickedUp: false,
      };

      if (
        (sourceType === 0 &&
          currentOrderStatusType === 'Pending' &&
          unpaidAmount > 0 &&
          tickets?.length > 0 &&
          unpaidAmount !== totalAmount) ||
        (sourceType !== 0 && currentOrderStatusType === 'Pending')
      ) {
        flags.isPending = true;
      } else if (
        currentOrderStatusType === 'In Progress' ||
        (currentOrderStatusType === 'Pending' &&
          sourceType === 0 &&
          (unpaidAmount === 0 || unpaidAmount === totalAmount))
      ) {
        flags.isInProgress = true;
      } else if (orderStatusId === 5 && pickUpStatus === 0) {
        const { clearTime } = cutoffTimeCalculation(check);
        flags.isComplete = !(clearTime && currentTime > clearTime);
      } else if (orderStatusId === 5 && pickUpStatus === 5) {
        flags.isPickedUp = true;
      }
      return { ...flags, order0, orderStatusId };
    };

    const assignColorAndPush = (check, flags, currentTime) => {
      const {
        order0,
        orderStatusId,
        isPending,
        isInProgress,
        isComplete,
        isPickedUp,
      } = flags;
      const {
        comingUpTime,
        prepTime,
        warningTime,
        errorTime,
      } = cutoffTimeCalculation(check);
      const pickupTime = getTimeInMilliSeconds(order0?.pickupDate);

      let color;
      if (isPending) {
        if (
          orderStatusId === 0 &&
          comingUpTime < currentTime &&
          comingUpTime < prepTime
        ) {
          color = 'orange';
        } else if (orderStatusId === 0 && currentTime > prepTime) {
          color = 'red';
        }
        pendingChecks.push({ ...check, color });
      } else if (isInProgress) {
        if (currentTime > pickupTime) color = 'red';
        inProgressChecks.push({ ...check, color });
      } else if (isComplete) {
        if (
          warningTime &&
          errorTime &&
          currentTime > warningTime &&
          currentTime < errorTime
        ) {
          color = 'orange';
        } else if (errorTime && currentTime > errorTime) {
          color = 'red';
        }
        completeChecks.push({ ...check, color });
      } else if (isPickedUp) {
        if (
          warningTime &&
          errorTime &&
          currentTime > warningTime &&
          currentTime < errorTime
        ) {
          color = 'orange';
        } else if (errorTime && currentTime > errorTime) {
          color = 'red';
        }
        pickedUpChecks.push({ ...check, color });
      }
    };

    checks?.forEach(check => {
      const flags = getOrderFlags(check, currentTime);
      assignColorAndPush(check, flags, currentTime);
    });

    setPendingCheckList(pendingChecks);
    setInProgressCheckList(inProgressChecks);
    setCompleteCheckList(completeChecks);
    setPickedUpCheckList(pickedUpChecks);
  };

  const getModes = check => {
    const { sourceType, tab } = check || {};
    let delivery = false;
    let isMarketPlaceOrder = false;
    let isCatering = false;
    const getIconColor = isExpanded ? '#FFFFFF' : 'var(--primary-icon-color)';
    const imgSrc = getCheckSourceIcon(
      sourceType,
      getIconColor,
      delivery,
      isMarketPlaceOrder,
      isCatering,
      tab
    );
    return imgSrc;
  };

  const getModesBgColor = check => {
    const { sourceType, tab } = check || {};
    let delivery = false;
    let isMarketPlaceOrder = false;
    let isCatering = false;
    const bgColor = getModeIconBgColor(
      sourceType,
      delivery,
      isMarketPlaceOrder,
      isCatering,
      tab
    );
    return bgColor;
  };

  const getCheckStatus = check => {
    const statusWithColor = getOrderNameFromOrderId(check);
    return statusWithColor;
  };

  const getVenueStoresName = storeId => {
    const venuesInfoList = venueStores?.saStoreInfos;
    const storeFromVenue = venuesInfoList?.find(store => store.id === storeId);
    return venuesInfoList ? storeFromVenue?.name : storeInfo?.name;
  };

  const getFormattedChecks = () => {
    const formattedChecks = filteredCheckListItem?.map(check => {
      const [order0] = check?.orders || [];
      const pickupTimeInMS = getElapsedTimeInMs(order0?.pickupDate);
      const dueTimeDisplay = getDueTime(check);
      const AllItems = [
        ...(check?.Items ?? check?.items ?? []),
        ...(check?.PendingItems || []),
      ];
      return {
        ...check,
        AllItems,
        selectedCheckDetails: check,
        checkNumber: check.checkNumber,
        number: check.number,
        id: check.id,
        checkHeaderId: check.checkHeaderId,
        deliverTo: getDeliverTo(check),
        pickupDateInMS: getTimeInMilliSeconds(check.pickupDate),
        status: getCheckStatus(check),
        mode: getModes(check),
        modeBgColor: getModesBgColor(check),
        sourceType: check.sourceType,
        unFormattedPhoneNumber: check.phoneNumber,
        orderStatusId: check.orderStatusId,
        pickupDate: order0.pickupDate,
        pickupTimeInMS: pickupTimeInMS,
        orderDate: check.orderDate,
        openDate: check.openDate,
        orders: check.orders,
        orderTypeId: check.orderTypeId,
        checkName: check.name,
        checkInNote: check.checkInNote,
        unpaidAmount: check.unpaidAmount,
        open: check.open,
        stationId: check.stationId,
        referenceId: check.referenceId,
        taxAmount: check.taxAmount,
        subTotalAmount: check.subTotalAmount,
        totalAmount: check.totalAmount,
        guestName: check.guestName,
        items: check.items,
        tickets: check.tickets,
        seats: check.seats,
        stationName: check.stationName,
        employeeFirstName: check.employeeFirstName,
        employeeLastName: check.employeeLastName,
        dueTime: getTimeInHrsMins(dueTimeDisplay),
        ellapsedTime: check.openDate,
        // preAuthIcon: preAuthIcon,
        // paid: preAuthIcon || paidIcon,
        checkInTime: getCheckInTime(check),
        checkInTimeForSorting: new Date(check.checkInDate).getTime(),
        phoneNumber: check.phoneNumber
          ? getFormatedPhoneNumber(check?.phoneNumber)
          : '- -',
        orderDetails: {
          orderName: check.name,
          phoneNumber: check.phoneNumber
            ? getFormatedPhoneNumber(check?.phoneNumber)
            : '---',
          isPhoneNumber: check.phoneNumber,
        },
        timeDetails: {
          ellapsedTime: check.openDate,
          dueDate: getTimeInHrsMins(dueTimeDisplay),
        },
        tableInfo: {
          tab: check.tab,
          stationName: check.stationName,
          stationNumber: check.stationNumber,
        },
        paymentDetails: {
          paidAmount: check.paidAmount,
          unpaidAmount: check.unpaidAmount,
        },
        openDateDetails: {
          openDate: getFormattedOpenOrCloseDate(check?.openDate),
          closeDate: getFormattedOpenOrCloseDate(check?.closeDate),
          ellapsedTime: check.openDate,
          ellapsedTimeColor: check.openDate,
        },
        guestDetails: {
          guestCount: check?.guestCount,
          phoneNumber: check.phoneNumber
            ? getFormatedPhoneNumber(check?.phoneNumber)
            : '---',
          isPhoneNumber: check.phoneNumber,
          countryCode: check?.orders[0]?.countryCode,
        },
        remainingTimeDetails: {
          remainingTime: check?.pickupDate,
          dueDate: getTimeInHrsMins(dueTimeDisplay),
        },
        storeInfoDetails: {
          storeName: getVenueStoresName(check?.storeId),
        },
      };
    });

    return formattedChecks || [];
  };

  const checksRowData = useMemo(() => {
    const checks = getFormattedChecks();
    refreshSectionChecks(checks);
    return checks;
  }, [filteredCheckListItem, tableData]);

  const sortChecksByTime = (a, b) => {
    const time1 = a.pickupDateInMS;
    const time2 = b.pickupDateInMS;
    return time1 - time2;
  };

  const onTileClicked = data => {
    setSelectedCheck(data);
  };

  const viewProps = () => {
    const checkSortFunc = sortChecksByTime;
    const sortedPendingChecks = [...pendingCheckList].sort(checkSortFunc);
    const sortedInProgressChecks = [...inProgressCheckList].sort(checkSortFunc);
    const sortedCompleteChecks = [...completeCheckList].sort(checkSortFunc);
    const sortedPickedUpChecks = [...pickedUpCheckList].sort(checkSortFunc);

    return {
      ...checks,
      checksRowData,
      storeInfo,
      deviceGroup: deviceInfo?.deviceGroup,
      pendingCheckList: sortedPendingChecks,
      inProgressCheckList: sortedInProgressChecks,
      completeCheckList: sortedCompleteChecks,
      pickedUpCheckList: sortedPickedUpChecks,
      onFooterButtonPress,
      currency,
      currentView,
      onTileClicked,
      selectedCheck,
      setSelectedCheck,
      supportsTipsOnTotalAmount,
      suppressTipsOnFireBoard,
      setPopup,
      popup,
      setIsFlip,
      isExpanded,
      setIsExpanded,
      currentMode,
      filterByOrderTypes,
      setFilteredCheckListItem,
      setIsPickedUpCol,
      isPickedUpCol,
    };
  };

  return (
    <div className="col-12 px-0 h-100">
      <Views {...viewProps()} />
    </div>
  );
};

const mapStateToProps = ({
  storeNotifications,
  storeChecks,
  oauth,
  venue,
}) => ({
  notificationTableData: storeNotifications.storeNotification,
  tableData: { ...storeChecks.checkListHashTable },
  currentMode: oauth.currentMode,
  venueStores: venue.venueStores,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      newUpdateOrderStatus,
      newOrderPickedUp,
      setNotification,
      setErrorPopUp,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(OrderStatusManager);
